// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var assetBundleGrounds = {
    grounds_0: require("../assets/packed/grounds/grounds-0.json"),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleGrounds.ts
// module id = 1735
// module chunks = 3